import React, { useState } from 'react';
import { Grid3x3, Sliders } from 'lucide-react';

import GprsGrade from './GprsGrade';
import GprsConsulta from './GprsConsulta';
import { perfilNoModulo } from '../../../utils/perfisDerivados';

// =====================================================================
// FINANCEIRO — Controle de GPRS: a CASCA do sub-módulo.
//
// Um card só no hub, com duas telas em abas internas — o padrão dos vizinhos
// (`Nulos.js`, `FinanceiroEstorno.js`):
//   · Grade do mês  → a loja digita, no lugar da planilha do SharePoint;
//   · Consulta      → o escritório olha a rede inteira num período.
//
// ⚠️ `Diretoria` lê e NÃO digita — ela acompanha a rede, não preenche o
//    fechamento diário de uma loja. Aqui isso só decide qual aba abre; quem barra
//    a escrita é o `authorizeRoles` do `server-gprs.js`, e a própria grade só
//    desenha o botão Salvar se a API disser `podeDigitar`.
// =====================================================================

// Paleta do módulo FINANCEIRO (verde-petróleo) — fonte da verdade é o `cor=` do
// ModuloHeader no hub (docs/ARQUITETURA.md › Paleta dos módulos).
const COR = '#0d7a74';
const COR_FORTE = '#115e59';
const COR_FUNDO = '#f0fdfa';

const PERFIS_SO_LEITURA = ['Diretoria'];

const FinanceiroGprs = () => {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    // ⚠️ Traduzido no módulo: `Diretoria Op` responde como `Diretoria` aqui — e
    //    apenas aqui.
    const userRole = perfilNoModulo(user?.perfil, 'financeiro') || '';
    const somenteLeitura = PERFIS_SO_LEITURA.includes(userRole);

    const [aba, setAba] = useState(somenteLeitura ? 'consulta' : 'grade');

    const estiloAba = (ativa) => ({
        display: 'flex', alignItems: 'center', gap: 8, padding: '10px 20px',
        backgroundColor: ativa ? COR_FUNDO : 'transparent',
        color: ativa ? COR_FORTE : '#64748b',
        border: 'none', borderRadius: 8, fontWeight: 600, cursor: 'pointer',
        transition: 'all 0.2s', fontSize: 14,
        boxShadow: ativa ? `inset 0 -2px 0 ${COR}` : 'none',
    });

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 24 }}>
            <div>
                <h2 style={{ fontSize: 22, fontWeight: 800, color: '#0f172a', margin: '0 0 6px 0' }}>
                    Controle de GPRS
                </h2>
                <p style={{ fontSize: 14, color: '#64748b', margin: 0, lineHeight: 1.6 }}>
                    A conferência da venda do TEF móvel (a maquininha que anda pela loja) contra o que os
                    sistemas registraram — o que antes era a planilha mensal no SharePoint.
                </p>
            </div>

            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 12, borderBottom: '1px solid #e2e8f0', paddingBottom: 16 }}>
                {!somenteLeitura && (
                    <button onClick={() => setAba('grade')} style={estiloAba(aba === 'grade')}>
                        <Grid3x3 size={18} /> Grade do mês
                    </button>
                )}
                <button onClick={() => setAba('consulta')} style={estiloAba(somenteLeitura || aba === 'consulta')}>
                    <Sliders size={18} /> Consulta
                </button>
            </div>

            <div style={{ paddingTop: 8 }}>
                {somenteLeitura || aba === 'consulta' ? <GprsConsulta /> : <GprsGrade />}
            </div>
        </div>
    );
};

export default FinanceiroGprs;
